<div class="pt-4 d-flex bd-highlight">
  @for (feature of toDisplay; track feature; let i = $index) {
    <div class="lds-container p-2 flex-even bd-highlight" [ngClass]="i===0 ? '': 'ml-2'">
      <div class="name-title">
        {{capitalizeFirstLetter(feature.name)}}
      </div>
      <hr>
        <div class="mid-text lw-green-text" [style.color]="statusColorLoopup(feature.status)">
          {{feature.value}}
        </div>
        <div class="unit-text">
          {{feature.unit}}
        </div>
      </div>
    }
  </div>
  <!-- <div class="d-flex bd-highlight p-2 mb-3" >
  <div class="p-2 flex-fill bd-highlight">Flex item</div>
  <div class="p-2 flex-fill bd-highlight">Flex item</div>
  <div class="p-2 flex-fill bd-highlight">Flex item</div>
</div> -->
